import { FiRefreshCcw } from 'react-icons/fi';
import { renderIcon } from 'utils/icon.utils';
import './Button-reload.scss';

interface ButtonReloadProps {
  onClick: () => void;
}

const ButtonReload = ({ onClick }: ButtonReloadProps) => {
  return (
    <button className="button-reload" onClick={onClick}>
      {renderIcon(FiRefreshCcw, { className: 'icon' })}
    </button>
  );
};

export default ButtonReload;
